import { render, staticRenderFns } from "./abas_article.vue?vue&type=template&id=aa426c00"
import script from "./abas_article.vue?vue&type=script&lang=js"
export * from "./abas_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports